import React from 'react'

import Item from './Item'

class Section extends React.Component {

  // returns complete or active depending on state passed
  listGroupClass() {
    let { data } = this.props

    switch(data.overall) {
      case 'completed':
        return 'complete'
        break;
      case 'in_progress':
        return 'active'
        break
      default:
        return ''
    }
  }

  isCurrentState(state) {
    let { active } = this.props
    return active.includes(state)
  }

  hasBeenCompleted(state) {
    let { completed } = this.props
    return completed.includes(state)
  }

  renderItems() {
    let {
      data,
      onClick
    } = this.props

    return data.states.map((state) => (
      <Item
        key={state}
        onClick={ onClick }
        state={state}
        active={ this.isCurrentState(state) }
        completed={ this.hasBeenCompleted(state) }
      />
    ))
  }

  render() {
    let { section } = this.props
    return(
      <li key={section} className={ `list-group-item ${ this.listGroupClass() }` } >
        { I18n.t(`loan_application_user.sections.titles.${section}`) }
        <ul className="list-unstyled child-nav">
          { this.renderItems() }
        </ul>
      </li>
    )
  }
}

export default Section;

